import { SceneComponent } from 'src/sdk-components/SceneComponent';

export class ShowcaseContext extends SceneComponent {
  public get() {
    return this.context;
  }
}

export const showcaseContextComponentType = 'mp.showcaseContext';
export const makeShowcaseContext = () => new ShowcaseContext();
